import TemplateAnalyticsAdmin from "./TemplateAnalyticsAdmin";

const TemplateAnalyticsAdminConfig = {
	settings: {},
	routes: [
		{
			path: '/reports/template-analytics',
			component: TemplateAnalyticsAdmin
		}
	]
};

export default TemplateAnalyticsAdminConfig;
